import React from "react";
import { Link } from "react-router-dom";

const Head = () => {
  return (
    <header className="w-full mb-1 bg-black text-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        
        {/* Main Wrapper */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">

          {/* LEFT: LOGO */}
          <Link to="/" className="flex-shrink-0">
            <div className="bg-white p-2 rounded-md">
              <img
                src="/assets/images/envelop.png"
                alt="Logo"
                className="h-8 sm:h-10 md:h-12 object-contain"
              />
            </div>
          </Link>

          {/* RIGHT: CONTACT INFO */}
          <div className="flex flex-row items-center text-center sm:text-right gap-2 sm:gap-4 text-xs sm:text-sm md:text-base">

            {/* Phone */}
            <div className="flex items-center gap-1">
              <span className="font-medium">Call:</span>
              <a
                href="tel:+917030055128"
                className="hover:text-blue-400 transition duration-200 break-all"
              >
                +91-7030055128
              </a>
            </div>

            {/* Divider for tablet/desktop */}
            <span className="hidden sm:block text-gray-400">|</span>

            {/* Email */}
            <div className="flex items-center gap-1 flex-wrap justify-center sm:justify-end">
              <span className="font-medium">Email:</span>
              <a
                href="mailto:enquiry@thinkquotient.ai"
                className="hover:text-blue-400 transition duration-200 break-all"
              >
                enquiry@thinkquotient.ai
              </a>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
};

export default Head;